<template>
	<div class="stage stage--swipequiz-waiting" v-if="state === 'ready'" :style="{ 'background-image': backgroundImage }">

		<div class="swipequiz__background-overlay background-overlay">

			<div class="content-container">
				<div class="header__container shadow-box">
					<div class="subHeader" style="position: relative">
					</div>
					<div class="header" style="position: relative">
						Idle screen
					</div>
					<div class="text" style="position: relative">
						even geduld
					</div>
				</div>
			</div>
		</div>

		

	</div>


	<div class="swipequiz stage stage--swipequiz" v-else-if="state === 'question'" :style="{ 'background-image': backgroundImage }">

		<div class="swipequiz__background-overlay background-overlay">

			<div class="content-container">

				<HeaderBlock :header="questionData.header" :subHeader="roundData.questions.subheader" :bodytext="questionData.questiontext" />

				<div class="btn__explanation" @click="showExplanationPopup">
					<i class="fa fa-question"></i>
				</div>

				<Timer key="timer" :percentage="timerPercentage"/>

				<SwipeImage
						v-if="questionData != null"
						:image="baseUrl + questionData.visual"
						@onanswer="onQuestionAnswer"
						dead-zone="50"
						:header="questionData.subheader"
				        :questiontext="questionData.caption"
				        :cardbg="baseUrl + roundData.questions.swipe_card_bg"
				/>

				<div class="swipequiz__btn-container">

					<div class="input-holder input-holder__three-btn-circle" @click="onQuestionAnswer('No')">
						<div class="btn btn-circle btn-circle-wrong">
							<i class="fa fa-times" aria-hidden="true"></i>
						</div>
					</div>
					
					<div class="input-holder input-holder__three-btn-circle" @click="onQuestionAnswer('Dont know')">
						<div class="btn btn-circle btn-circle-questionmark">
							<i class="fa fa-question" aria-hidden="true"></i>
						</div>
					</div>

					<div class="input-holder input-holder__three-btn-circle" @click="onQuestionAnswer('Yes')">
						<div class="btn btn-circle btn-circle-good">
							<i class="fa fa-check" aria-hidden="true"></i>
						</div>
					</div>
				</div>
			
			</div>	
			
		</div>

		<ExplanationPopup 
			v-if="explanationPopupActive == true" 
			:additionalHTML="additionalHTML"
			:on-click="hideExplanationPopup"/>
	</div>

	<div class="stage stage--swipequiz-feedback" v-else-if="state === 'feedback'" :style="{ 'background-image': backgroundImage }">

		Feedback screen

	</div>
	

</template>

<script>

	import HeaderBlock from '../HeaderBlock.vue';
	import Timer from '../../Timer.vue';
	import Score from '../../Score.vue';
	import SwipeImage from './SwipeImage.vue';
	import Question from './Question.vue';
	import { url } from '../../../const/base';
	import { mapGetters , mapActions } from 'vuex';
	import Velocity from 'velocity-animate';
	import ExplanationPopup from '../ExplanationPopup.vue';

	export default {

		components:{
			HeaderBlock,
			Timer,
			Score,
			Question,
			SwipeImage,
			ExplanationPopup,
		},

		data(){
			return{
				baseUrl : url,
				time: 600,
				timeCounter: 600,
				timeInterval: .1,
				intervalEvent: -1,
				score: 0,
				answers: [],
				mappedSdgs: [],
				explanationPopupActive: false,
				additionalHTML:"",
				state: "ready", //ready, question , feedback
				use_feedback_state: true,
				room_id: false,
			}
		},

		beforeMount(){
			this.buildInfoAddonHTML();

			let self = this;

			this.$socket.on('joined_update', function(data){

				console.log('joined');
				console.log(data);
				
				self.room_id = data.data.id;		
			});

			this.$socket.on('goto_first_question', function(data){
				console.log(data);
				
				self.state = "question";		
			});

			this.$socket.on('goto_next_question', function(data){
				console.log(data);
				
				if(self.lastQuestion) self.finishRound();
				else self.toNextQuestion();
				self.state = "question";

				self.time = +self.roundData.questions.time;
				self.timeCounter = self.time;
				if(self.time > 0){
					self.startTimer();
				}

			});
		},

		mounted(){
			this.showTransitorScore(true);
			this.time = +this.roundData.questions.time;
			this.timeCounter = this.time;
			if(this.time > 0){
				this.startTimer();
			}

			// console.log('roundData');
			// console.log(this.roundData.questions);

			var data = {'instance_id': this.instanceId, 'client_id':this.userId, 'teamcode':this.teamCode};
            this.$socket.emit('join_instance', data);
		},

		computed: {

			...mapGetters([
				"lastQuestion",
				"questionData",
				"roundData",
				"instanceId",
				"userId",
				"teamCode",
			]),

			questionCount(){
				return this.roundData.questions.questions.length;
			},

			timerPercentage(){
				return (this.timeCounter / this.time)*100;
			},

			backgroundImage: function() {

				if(typeof this.roundData.questions.question_background === 'undefined' || this.roundData.questions.question_background === null){ 
					return 'none';
				}

		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },

		},

		methods:{

			buildInfoAddonHTML(){
				this.additionalHTML = this.roundData.questions.rules;	
			},

			hideExplanationPopup(){
				this.explanationPopupActive = false;
				$('.btn--transition').removeClass('idle');
			},

			showExplanationPopup(){
				this.explanationPopupActive = true;
				$('.btn--transition').addClass('idle');
			},

			startTimer(){
				if(this.intervalEvent != -1) window.clearInterval(this.intervalEvent);
				this.timeCounter = this.time;


				this.intervalEvent = window.setInterval(() => {
					this.timeCounter -= this.timeInterval;
					if(this.timeCounter <= 0){
						this.timeCounter = 0;
						this.stopTimer();
						this.finishRound();
					}
				},this.timeInterval*1000);
			},

			stopTimer(){
				window.clearInterval(this.intervalEvent);
				this.intervalEvent = -1;
			},

			...mapActions([
				"completeRound",
				"toNextQuestion",
				"setRoundScore",
				"increaseTransitorScore",
                "showTransitorScore",
				"logAnswers",
				"logSdgs",
			]),


			finishRound(){
				this.stopTimer();

				console.log('finishRound');
				console.log((this.score / this.questionCount)*100);

				console.log('answers:');
				console.log(this.answers);

				this.setRoundScore((this.score / this.questionCount)*100).then(()=>{
					this.logAnswers(this.answers).then(()=>
					{
						this.logSdgs(this.mappedSdgs).then(()=>{
							this.completeRound();
						});
					});
				});
			},
			
			onQuestionAnswer(e){
				this.answers.push(e);
				if(e == this.questionData.answer){

					//store the sdg's mapped to this question
					if(typeof this.questionData.sdg_mapping !== 'undefined'){
							
						console.log('sdgs mapping:');

						//check if it's a single entry or comma seperated
						let sdgMappingObject = this.questionData.sdg_mapping.split(",");

						console.log(sdgMappingObject);

						for (var i = 0; i < sdgMappingObject.length; i++) {
							this.mappedSdgs.push(sdgMappingObject[i]);
						};
					}
					
					let transitors = 1;
					if(this.score > 9){
						transitors = 6;
					}

					this.increaseTransitorScore(parseInt(this.roundData.questions.transitor_multiplier)*transitors);
					this.score ++;
				}

				console.log('score: '+this.score);


				if(this.use_feedback_state){

					this.stopTimer();

					this.state = "feedback";
					//log users state to node server
					// let self = this;
					// window.setTimeout(function(){
					// 	if(self.lastQuestion) self.finishRound();
					// 	else self.toNextQuestion();
					// 	self.state = "question";
					// }, 4000);

					let data = {'instance_id': this.instanceId, 'room_id':this.room_id, 'client_id':this.userId, 'answer':e};
					this.$socket.emit('set_answer', data);

				}else{

					if(this.lastQuestion) this.finishRound();
					else this.toNextQuestion();
				}
			},


		}

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/swipequiz/Index.vue